
import Settings from "../mixins/settings";
export default {
    mixins:[Settings],
    data(){
        return{
            pipeline_loading: false,
            temp_pipelines: [],
            pipeline_count: 0,
            pipeline_scrollable: false,
            pipeline_visible: false,
            deals_pipeline_options: [],
            add_pipeline: ""
        }
    },
    methods:{
        async searchPipelines(pipeline) {
            this.add_pipeline = pipeline
            this.assign_loading = true
            this.pipeline_loading = true
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: pipeline || '',
            }
            let response = await this.getDealsPipelineList(params)
            this.deals_pipeline_options = response.response
            this.pipeline_count = this.deals_pipeline_options.length
            this.pipeline_loading = false
            this.pipeline_scrollable = false
            if(String(this.$route.path).startsWith('/deals/dealdetails/')){
                this.deal_pipeline = this.deals_pipeline_options[0]
            }
        },
        async reachedEndOfPipelines(reached) {
            this.pipeline_visible = reached
            if (reached) {
                if (this.pipeline_scrollable == false) {
                    this.pipeline_loading = true
                    let response = await this.getDealsPipelineList({
                        skip: this.pipeline_count,
                        limit: 10,
                        search_key: ""
                    })
                    this.temp_pipelines = response.response.length;
                    if (response.skip == this.pipeline_count) {
                        if (this.temp_pipelines > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.deals_pipeline_options.push(el);
                            });
                            this.deals_pipeline_options = this.deals_pipeline_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.deals_pipeline_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.pipeline_count += response.response.length;
                            this.pipeline_loading = false
                        } else {
                            this.pipeline_scrollable = true
                            this.pipeline_loading = false
                        }
                    }
                    this.pipeline_loading = false
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/pipeline_lazyloading.js